import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "hero" }
const _hoisted_2 = { class: "hero-body" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "content-body" }
const _hoisted_6 = { class: "header" }
const _hoisted_7 = {
  key: 0,
  class: "title is-5"
}
const _hoisted_8 = {
  key: 1,
  class: "title is-5"
}
const _hoisted_9 = { class: "columns" }
const _hoisted_10 = { class: "column is-half" }
const _hoisted_11 = { class: "field" }
const _hoisted_12 = { class: "label" }
const _hoisted_13 = { class: "control" }
const _hoisted_14 = ["placeholder", "disabled"]
const _hoisted_15 = {
  key: 0,
  class: "content-body"
}
const _hoisted_16 = { class: "label mt-4" }
const _hoisted_17 = { class: "table-container mb-2" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = { class: "" }
const _hoisted_20 = {
  key: 0,
  class: ""
}
const _hoisted_21 = {
  key: 1,
  class: ""
}
const _hoisted_22 = { class: "sticky-column" }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { class: "content-body" }
const _hoisted_25 = {
  key: 0,
  class: "header is-flex is-justify-content-space-between"
}
const _hoisted_26 = { class: "content-body" }
const _hoisted_27 = { class: "field is-grouped is-grouped-right" }
const _hoisted_28 = {
  key: 0,
  class: "control"
}
const _hoisted_29 = {
  type: "submit",
  class: "button is-primary"
}
const _hoisted_30 = {
  key: 1,
  class: "control"
}
const _hoisted_31 = {
  key: 2,
  class: "control"
}
const _hoisted_32 = {
  key: 3,
  class: "control"
}
const _hoisted_33 = { class: "content-body" }
const _hoisted_34 = { class: "header" }
const _hoisted_35 = { class: "title is-5 mt-4" }
const _hoisted_36 = { class: "field is-grouped is-grouped-right" }
const _hoisted_37 = { class: "control" }
const _hoisted_38 = {
  type: "submit",
  class: "button is-primary"
}
const _hoisted_39 = { class: "control" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_SpecialtyDataFileTableRow = _resolveComponent("SpecialtyDataFileTableRow")!
  const _component_SpecialtyDataFileDataForm = _resolveComponent("SpecialtyDataFileDataForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Navbar),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("form", {
              onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.editSpecialtyMeth && _ctx.editSpecialtyMeth(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("form", {
                  onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.editSpecialtyMeth && _ctx.editSpecialtyMeth(...args)), ["prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    (_ctx.getEditingSpecialty)
                      ? (_openBlock(), _createElementBlock("h5", _hoisted_7, _toDisplayString(_ctx.$t('SpecialtyData.PleaseModifySpecialtyData')), 1))
                      : _createCommentVNode("", true),
                    (!_ctx.getEditingSpecialty)
                      ? (_openBlock(), _createElementBlock("h5", _hoisted_8, _toDisplayString(_ctx.$t('SpecialtyData.SpecialtyData')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('SpecialtyData.Name')), 1),
                        _createElementVNode("div", _hoisted_13, [
                          _withDirectives(_createElementVNode("input", {
                            minlength: 2,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.getEditedSpecialtyData.name) = $event)),
                            class: "input",
                            type: "text",
                            placeholder: _ctx.$t('SpecialtyData.NamePlaceholder'),
                            required: "",
                            disabled: !_ctx.getEditingSpecialty
                          }, null, 8, _hoisted_14), [
                            [_vModelText, _ctx.getEditedSpecialtyData.name]
                          ])
                        ])
                      ])
                    ])
                  ])
                ], 32)
              ]),
              (!_ctx.addingFile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('FilesData.Files')), 1),
                    _createElementVNode("div", _hoisted_17, [
                      (_openBlock(), _createElementBlock("table", {
                        class: "table",
                        key: _ctx.getEditedSpecialtyData.specialty_id
                      }, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('FilesData.FileContent')), 1),
                            _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t('FilesData.FileType')), 1),
                            (_ctx.getAccessType != 'customer')
                              ? (_openBlock(), _createElementBlock("th", _hoisted_20, _toDisplayString(_ctx.$t('FilesData.FileSize')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.getAccessType != 'customer')
                              ? (_openBlock(), _createElementBlock("th", _hoisted_21, _toDisplayString(_ctx.$t('FilesData.FileUploadTime')), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.$t('FilesData.OpenContent')), 1),
                            (_ctx.getEditingSpecialty)
                              ? (_openBlock(), _createElementBlock("th", _hoisted_23, _toDisplayString(_ctx.$t('General.Operations')), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getEditedSpecialtyFiles, (file) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: _ctx.getEditedSpecialtyData.specialty_id + '-' + file.file_id + '-' + file.pos
                            }, [
                              (_openBlock(), _createBlock(_component_SpecialtyDataFileTableRow, {
                                "file-data": file,
                                key: _ctx.getEditedSpecialtyData.specialty_id + '-' + file.file_id + '-' + file.pos
                              }, null, 8, ["file-data"]))
                            ]))
                          }), 128))
                        ])
                      ]))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_24, [
                (!_ctx.addingFile && _ctx.getEditingSpecialty)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("div", null, [
                        _createElementVNode("button", {
                          class: "button is-primary",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleAddingFile && _ctx.toggleAddingFile(...args)))
                        }, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('FilesData.NewFile')), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  (_ctx.getEditingSpecialty)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_28, [
                        _createElementVNode("button", _hoisted_29, _toDisplayString(_ctx.$t('General.Save')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.getEditingSpecialty)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_30, [
                        _createElementVNode("a", {
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelEditing && _ctx.cancelEditing(...args))),
                          class: "button is-light"
                        }, _toDisplayString(_ctx.$t('General.Cancel')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.getEditingSpecialty && !_ctx.getSpecialtyDetailing)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_31, [
                        _createElementVNode("a", {
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.iniSpecialtyEditing && _ctx.iniSpecialtyEditing(...args))),
                          class: "button is-primary"
                        }, _toDisplayString(_ctx.$t('General.ModifyData')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.getSpecialtyDetailing)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_32, [
                        _createElementVNode("a", {
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.endSpecialtyDetailing && _ctx.endSpecialtyDetailing(...args))),
                          class: "button is-primary"
                        }, _toDisplayString(_ctx.$t('General.Back')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                (_ctx.addingFile)
                  ? (_openBlock(), _createElementBlock("form", {
                      key: 0,
                      onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addFileMeth && _ctx.addFileMeth(...args)), ["prevent"]))
                    }, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("h5", _hoisted_35, _toDisplayString(_ctx.$t('FilesData.AddNewFile')), 1)
                      ]),
                      _createVNode(_component_SpecialtyDataFileDataForm, { ref: "refNewFileDataForm" }, null, 512),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("p", _hoisted_37, [
                          _createElementVNode("button", _hoisted_38, _toDisplayString(_ctx.$t('General.Add')), 1)
                        ]),
                        _createElementVNode("p", _hoisted_39, [
                          _createElementVNode("a", {
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleAddingFile && _ctx.toggleAddingFile(...args))),
                            class: "button is-light"
                          }, _toDisplayString(_ctx.$t('General.Cancel')), 1)
                        ])
                      ])
                    ], 32))
                  : _createCommentVNode("", true)
              ])
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}